import {isHeicConvertibleFile} from './is-file-heic';

export function fileListIncludesHeic(fileList: FileList): boolean {
  return Array.from(fileList).some(file => {
    return isHeicConvertibleFile(file);
  });
}
